if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Product thumbnails
			this.querySelectorAll('[data-js-product-tabs]').forEach(tabs=>{
				tabs.querySelectorAll('label').forEach(tab=>{
					tab.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							tab.click();
						}
					});
				})
			})

			this.querySelectorAll('.product-variant__item--color').forEach(elm=>{
				const selectedColor = elm.querySelector('input[type="radio"][checked][data-selected]');
				if ( selectedColor ) {
					selectedColor.closest('[data-js-product-variant]').querySelector('.product-variant__item-text-label').innerHTML = selectedColor.value;
				}
			});

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');
				const galleryItems = this.querySelectorAll('.product-gallery-item');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					// Set first item as active (desktop only)
					if (galleryItems.length > 0 && window.innerWidth >= 768) {
						galleryItems[0].classList.add('active');
					}

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							const targetIndex = e.currentTarget.dataset.index;
							
							// Update active thumbnail
							this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach(thumb => thumb.classList.remove('active'));
							e.currentTarget.classList.add('active');
							
							// Desktop: use active class system
							if (window.innerWidth >= 768) {
								// Remove active class from all items
								galleryItems.forEach(item => item.classList.remove('active'));
								
								// Add active class to corresponding gallery item
								const targetGalleryItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${targetIndex}"]`);
								if (targetGalleryItem) {
									targetGalleryItem.classList.add('active');
								}
								
								this._pauseAllMedia();
								this._playMedia(targetGalleryItem);
								
								// Update thumbnail height after image change
								setTimeout(() => {
									this.matchThumbnailHeight();
								}, 100);
								
								// Scroll thumbnail into view vertically
								productGaleryThumbnails.scrollTo({
									top: elm.offsetTop - 50,
									behavior: 'smooth'
								});
							} 
							// Mobile: use slider's native functionality
							else {
								if ( this.productSlider.sliderEnabled ) {
									this.productSlider.changeSlide(targetIndex);
								} else {
									// Fallback: scroll to image
									const targetGalleryItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${targetIndex}"]`);
									if (targetGalleryItem) {
										targetGalleryItem.scrollIntoView({
											behavior: 'smooth',
											block: 'nearest',
											inline: 'start'
										});
									}
								}
								
								// Scroll thumbnail into view horizontally
								productGaleryThumbnails.scrollTo({
									left: elm.offsetLeft - 50,
									behavior: 'smooth'
								});
							}
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
						
						// Update active gallery item (desktop only)
						if (window.innerWidth >= 768) {
							galleryItems.forEach(item => item.classList.remove('active'));
							const activeItem = this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`);
							if (activeItem) {
								activeItem.classList.add('active');
							}
							
							// Update thumbnail height after slide change
							setTimeout(() => {
								this.matchThumbnailHeight();
							}, 100);
						}
					});

					// Setup thumbnail scroll navigation (desktop only)
					this.setupThumbnailScrollNavigation();

					// Match thumbnail height on load and resize (desktop only)
					if (window.innerWidth >= 768) {
						// Initial height match with a delay to ensure images are loaded
						setTimeout(() => {
							this.matchThumbnailHeight();
						}, 500);
					}
					
					// Update on window resize
					window.addEventListener('resize', () => {
						if (window.innerWidth >= 768) {
							this.matchThumbnailHeight();
						} else {
							// Reset on mobile
							if (this.querySelector('.product-gallery__thumbnails-holder')) {
								this.querySelector('.product-gallery__thumbnails-holder').style.maxHeight = '';
							}
						}
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', ()=>{
					this.productImageSlides = this.productSlider.querySelectorAll('.product-gallery-item');
					this.productImages = this.productSlider.querySelectorAll('.product-media-image');
					// Match height after slider is ready (desktop only)
					if (window.innerWidth >= 768) {
						setTimeout(() => {
							this.matchThumbnailHeight();
						}, 200);
					}
				});
				this.productSlider.addEventListener('scroll', ()=>{
					const scrollX = -this.productSlider.element.scrollLeft;
					this.productImageSlides.forEach((slide,i)=>{
						const img = this.productImages[i];
						if ( img ) {
							const slideX = slide.offsetLeft;
							img.style.transform = `translateX(${( slideX + scrollX ) * -1/3}px)`;
						}
					});
				});

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			this.productGallery.querySelectorAll('[data-js-video-popup-link]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this._pauseAllMedia();
				});
			})

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}
			
			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {

				// hide buy now button if stock disabled

				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });

			}

			// truncated descriptions

			if ( this.querySelector('[data-js-show-more]') ) {
				const showMore = this.querySelector('[data-js-show-more]');
				const productDescription = this.querySelector('.product__description');
				showMore.addEventListener('click', ()=>{
					productDescription.classList.toggle('product__description--truncated-initial');
					if ( productDescription.classList.contains('product__description--truncated-initial') ) {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowLess;
					} else {
						showMore.querySelector('.button__text').textContent = showMore.dataset.labelShowMore;
					}
				})
			}

			// recommended products
			
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-loaded', ()=>{
				this.querySelector('product-recommendations').classList.add('product-text-element--with-borders');
			});
			this.querySelector('product-recommendations')?.addEventListener('product-recommendations-error', ()=>{
				this.querySelector('product-recommendations').remove();
			});

		}

		matchThumbnailHeight() {
			const activeImage = this.productGallery.querySelector('.product-gallery-item.active');
			const thumbnailHolder = this.querySelector('.product-gallery__thumbnails-holder');
			
			if (activeImage && thumbnailHolder && window.innerWidth >= 768) {
				const imageHeight = activeImage.offsetHeight;
				thumbnailHolder.style.maxHeight = `${imageHeight}px`;
			}
		}

		setupThumbnailScrollNavigation() {
			const thumbnailsHolder = this.querySelector('.product-gallery__thumbnails-holder');
			const scrollUpBtn = this.querySelector('.product-gallery__thumbnails-scroll-btn.scroll-up');
			const scrollDownBtn = this.querySelector('.product-gallery__thumbnails-scroll-btn.scroll-down');
			
			if (!thumbnailsHolder || !scrollUpBtn || !scrollDownBtn) return;
			
			const scrollAmount = 150; // Adjust based on thumbnail height + gap
			
			// Update button states based on scroll position
			const updateButtonStates = () => {
				const isAtTop = thumbnailsHolder.scrollTop <= 0;
				const isAtBottom = thumbnailsHolder.scrollTop + thumbnailsHolder.clientHeight >= thumbnailsHolder.scrollHeight - 5;
				
				scrollUpBtn.disabled = isAtTop;
				scrollDownBtn.disabled = isAtBottom;
			};
			
			// Scroll up
			scrollUpBtn.addEventListener('click', () => {
				thumbnailsHolder.scrollBy({
					top: -scrollAmount,
					behavior: 'smooth'
				});
			});
			
			// Scroll down
			scrollDownBtn.addEventListener('click', () => {
				thumbnailsHolder.scrollBy({
					top: scrollAmount,
					behavior: 'smooth'
				});
			});
			
			// Update button states on scroll
			thumbnailsHolder.addEventListener('scroll', updateButtonStates);
			
			// Initial state
			updateButtonStates();
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							variantImg.scrollIntoView({behavior: 'auto', block: 'center'});
						}
					}
				}

			}

			this._pauseAllMedia();

		}

		_pauseAllMedia(){
			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI && model.modelViewerUI.pause ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			if (!media) return;
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}